import { Validator } from '@chedri/base';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();



Validator.isPhoneNumber = (val) => {
  if (!val) return false;

  let number = null;
  try {
    number = phoneUtil.parseAndKeepRawInput(String(val), 'DE');
  } catch (err) {
    return false;
  }

  return phoneUtil.isValidNumber(number);
};


Validator.isRegexPhoneNumberCountryCode = (val) => {
  if (!val) return false;

  // Country code check DE, UK, CH, AT, ES
  const regexPattern = /^\+(49|44|41|43|34)\d+$/;
  return regexPattern.test(String(val));
};

export default Validator;
